import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { AdminStateComponent } from './state.component';

@NgModule({
  declarations: [AdminStateComponent],
  imports: [CommonModule, MatButtonModule],
  exports: [AdminStateComponent],
})
export class AdminStateModule {}
